<template>
  <div class="Head-area">
    <div class="area container dis_flex dis_ali dis_jucontween">
      <div class="logo">
        <router-link to="/">
          <img src="../assets/04.png" alt="万杰智能科技股份有限公司" />
        </router-link>
      </div>
      <div class="other dis_flex dis_ali">
        <router-link to="/searchCenter" class="search">
          <img src="../assets/05.png" alt="万杰智能科技股份有限公司" />
        </router-link>
        <div class="en">
          <!-- http://www.wanjieen.com/ -->
          <a href="" target="_blank">En</a>
        </div>
        <div class="m-nav-btn dis_flex flex_direction dis_juconspace" @click="showNav = !showNav">
          <p></p>
          <p></p>
          <p></p>
        </div>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <div class="nav-list el-collapse-transition" v-if="showNav">
        <div class="nav-bg" @click="showNav = !showNav"></div>
        <el-collapse accordion @change="changeNav" class="box">
          <router-link to="/" class="nav-link dis_flex dis_ali">
            <div class="link-header">首页</div>
            <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
          </router-link>
          <el-collapse-item title="关于我们" name="2">
            <router-link to="/aboutus/intro">公司介绍</router-link>
            <router-link to="/aboutus/speech">董事长致辞</router-link>
            <router-link to="/aboutus/culture">企业文化</router-link>
            <router-link to="/aboutus/qualification">企业资质</router-link>
            <router-link to="/aboutus/bigevent">大事件</router-link>
            <router-link to="/aboutus/videos">视频展示</router-link>
          </el-collapse-item>
          <el-collapse-item title="新闻动态" name="3">
            <router-link to="/news/company">公司新闻</router-link>
            <router-link to="/news/industry">行业动态</router-link>
          </el-collapse-item>
          <el-collapse-item title="产品中心" name="4">
            <router-link
              :to="{path:'/productCenter',query:{typename:item.id}}"
              v-for="(item,index) in typeArr"
              :key="index"
            >{{item.name}}</router-link>
          </el-collapse-item>
          <el-collapse-item title="服务与合作" name="5">
            <router-link to="/serviceCooperation/problem">常见问题</router-link>
            <router-link to="/serviceCooperation/policy">维修政策</router-link>
          </el-collapse-item>
          <el-collapse-item title="投资者关系" name="6">
            <router-link to="/relationship/notice">公司公告</router-link>
            <router-link to="/relationship/members">董事会成员</router-link>
          </el-collapse-item>
          <el-collapse-item title="联系我们" name="7">
            <router-link to="/contactus/presale">售前咨询</router-link>
            <router-link to="/contactus/aftersales">售后支持</router-link>
            <router-link to="/contactus/message">在线留言</router-link>
          </el-collapse-item>
        </el-collapse>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      navindex: 0,
      navs: this.$router.options.routes,
      searchText: '',
      searchBarShow: false,
      showNav: false,
      typeArr: []
    }
  },
  watch: {
    '$route' (to, from, newxt) { // '$route.query' 这个函数是关键
      // console.log(to.paht)
      this.showNav = false
      // if (to.path !== '/searchCenter') {
      //   this.searchText = ''
      // }
    }
  },
  computed: {
    filterNav: function () {
      return this.navs.filter(function (item) {
        if (item.meta.show) {
          return item
        }
      })
    }
  },
  mounted () {
    // console.log(this.$router.options.routes)
    this.getType()
  },
  components: {

  },
  methods: {
    changeNav: function (item) {

    },
    getType: function () {
      this.$https.fetchPost('/Product/product_class_list', {
      }).then((res) => {
        // console.log(res.data, this.$route.query.typename)
        this.typeArr = res.data.data
      }).catch(err => {
        console.log(err)
      })
    }
  }

}
</script>
<style lang="less">
.Head-area {
  padding: 20px 0;
  position: relative;
  background: #ffffff;
  box-shadow: 3.9px 3.1px 9.5px 0.5px rgba(12, 3, 6, 0.02);
  .logo {
    width: 158px;
  }
  .other {
    .search {
      width: 28px;
      height: 28px;
    }
    .en {
      position: relative;
      font-family: MicrosoftYaHei;
      font-size: 28px;
      line-height: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0.7px;
      color: rgba(136, 136, 136, 1);
      padding: 0 22px;
      margin: 0 15px 0 22px;
      a {
        color: rgba(136, 136, 136, 1);
      }

      &::before {
        content: "";
        position: absolute;
        width: 2px;
        top: 0;
        left: 0;
        height: 30px;
        // margin-top: -6.5px;
        border-left: 1px solid #ebebeb;
      }
    }
    .m-nav-btn {
      height: 30px;
      p {
        width: 28px;
        height: 3px;
        background-color: rgba(51, 51, 51, 1);
        border-radius: 0.5px;
      }
    }
  }
  .nav-list {
    position: absolute;
    top: 95px;
    left: 0;
    width: 100%;
    z-index: 999;

    .nav-bg {
      min-height: calc(100vh - 95px);
    }
    .box {
      position: absolute;
      top: 0;
      width: 100%;
      box-shadow: 0px 11px 25.7px 7.3px rgba(12, 3, 6, 0.05);
    }
    .nav-link {
      background: rgba(255, 255, 255, 1);
      border-bottom: 1px solid rgba(239, 239, 239, 1);
      padding: 30px 15px 30px 34px;
      box-sizing: content-box;
      height: 48px;
      line-height: 48px;
      font-size: 30px;
      font-weight: normal;
      letter-spacing: 0.8px;
      font-family: PingFang-SC-Medium;
      color: rgba(34, 34, 34, 1);
    }
    .el-collapse-item {
      // background: rgba(255, 255, 255, .93);
      .el-collapse-item__header {
        font-family: PingFang-SC-Medium;
        font-size: 30px;
        font-weight: normal;
        letter-spacing: 0.8px;
        color: rgba(34, 34, 34, 1);
        padding: 30px 15px 30px 34px;
        box-sizing: content-box;
        background: rgba(255, 255, 255, 1);
      }
      .el-collapse-item__wrap {
        border-color: rgba(239, 239, 239, 1);
        padding: 0 34px;
        background: rgba(255, 255, 255, 1);
        a {
          font-family: PingFang-SC-Medium;
          font-size: 26px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: rgba(102, 102, 102, 1);
          display: inline-block;
          margin-right: 29px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue